import {SyntheticEvent} from 'react';
import {Options} from './types';

const limitSelectionRange = (e: SyntheticEvent<HTMLInputElement>, {prefix, suffix}: Options): SyntheticEvent<HTMLInputElement> => {
  let {selectionStart, selectionEnd, value} = e.currentTarget;
  if (selectionStart === selectionEnd) {
    // Max/min only when range is not a selection
    // selection is handled separatly
    selectionStart = Math.max(prefix.length, selectionStart);
    selectionEnd = Math.max(selectionStart, selectionEnd);
    selectionStart = Math.min(value.length - suffix.length, selectionStart);
    selectionEnd = Math.min(value.length - suffix.length, selectionEnd);
    e.currentTarget.setSelectionRange(selectionStart, selectionEnd);
  }
  return e;
}

export default limitSelectionRange;
